import { render, staticRenderFns } from "./CurencyAccountCard.vue?vue&type=template&id=a8816b8e&scoped=true&"
import script from "./CurencyAccountCard.vue?vue&type=script&lang=js&"
export * from "./CurencyAccountCard.vue?vue&type=script&lang=js&"
import style0 from "./CurencyAccountCard.vue?vue&type=style&index=0&id=a8816b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8816b8e",
  null
  
)

export default component.exports